import { observer } from 'mobx-react-lite'
import { Outlet, useLoaderData } from 'react-router'
import { useActivation } from '@/hooks/view-model-hooks'
import { Admin } from '@/features/admin/Admin'
import { type AdminViewModel } from '@/features/admin/AdminViewModel'
import { type AdminViewLoaderData } from '@/features/admin/admin-route-loaders'
import { AdminNavContainer } from '@/features/admin/components/AdminNav/AdminNavContainer'

export default observer(function AdminContainer() {
  const data = useLoaderData<AdminViewLoaderData>()
  return data ? <AdminContentContainer vm={data.vm} /> : null
})

interface AdminContentContainerProps {
  vm: AdminViewModel
}

const AdminContentContainer = observer(function AdminContentContainer({
  vm,
}: AdminContentContainerProps) {
  useActivation(vm)

  return (
    <Admin
      isNavVisible={vm.navVisible}
      onToggleNav={vm.toggleNavVisibility}
      nav={<AdminNavContainer vm={vm} />}
    >
      <Outlet context={vm} />
    </Admin>
  )
})
